import { Slider, styled as muiStyled } from '@material-ui/core';
import styled from 'styled-components';
import React from 'react';

const BlueSlider = muiStyled(Slider)({
  color: '#283890',
  height: 2, // <-- толщина линии
  '& .MuiSlider-thumb': {
    width: 12,
    height: 12,
    boxShadow: 'none', // убрали тень у ползунка
    '&:hover, &.Mui-focusVisible, &.Mui-active': {
      boxShadow: 'none'
    }
  },
  '& .MuiSlider-rail': {
    opacity: 0.3
  }
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin: 18px 0;
  & .label {
    font-family: NunitoSans;
    font-size: 12px;
    color: #677b8b;
    font-weight: bold;
  }
  & .values {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;
  }
`;

export default function ({ label, className, style, ...props }) {
  return (
    <Container className={className} style={style}>
      <div className='label'>{label || ''} </div>
      <BlueSlider {...props} />
      <div className='values'>
        <div>{props.min}</div>
        <div>{props.value}</div>
        <div>{props.max}</div>
      </div>
    </Container>
  );
}
